import React, { useState } from "react";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import "./styles.scss";
import googleMapsUrl from "../GoogleMaps/GoogleMaps";
import { confirmDelete } from "../../pages/PolygonsMaps/index";
import { FaRegTrashCan } from "react-icons/fa6";
import { Tooltip } from "@mui/material";
import { BiSolidMapPin } from "react-icons/bi";
import { MdEdit } from "react-icons/md";
import { array_forms } from "../../pages/PolygonsMaps";


/* global google */
function InfoReferencia({

  type,

  nome_referencia,

  latitude,

  longitude,

  center,

  map,

  valor,

  handleFunction,

  index,

  stateModal,

  activeModal,

  setConfirmRef,

  handleDelete,

  referenciaId,

  raio,

  cor,

  onDestacarRota,

  // =====================================================================================
  // EDIÇÃO
  // =====================================================================================

  setValues,

  setColor,

  color,

}) {
  const [isEditing, setIsEditing] = useState(false);

  const [editingId, setEditingId] = useState(null);

  const [editingShape, setEditingShape] = useState(null);

  // ========================================================
  // CENTRALIZA FORMA NO MAPA(DA ZOOM AO CLICAR NO PIN)
  // ========================================================
  const handleCenter = () => {
    console.log("MAP:", map);
    console.log("IS GOOGLE MAP:", map instanceof window.google.maps.Map);

    // ========================
    // CÍRCULO
    // ========================
    if (type === "circulo") {
      if (!isNaN(latitude) && !isNaN(longitude) && !isNaN(raio)) {

        const centerPoint = new google.maps.LatLng(latitude, longitude);

        const circle = new google.maps.Circle({
          center: centerPoint,
          radius: raio,
        });

        const bounds = circle.getBounds();

        if (bounds) {
          map.fitBounds(bounds);
        }

      } else {
        console.error("Coordenadas ou raio inválidos para 'circulo'.");
      }

      return;
    }

    // ========================
    // OUTROS TIPOS PRECISAM DE CENTER
    // ========================
    if (!center) {
      console.error("Centro ausente ou inválido.");
      return;
    }

    // ========================
    // ROTA
    // ========================

    if (type === "rota") {

      // centraliza normalmente
      const coordinatesArray = center.split("|").map((coord) => {
        const [lat, lng] = coord
          .replace("(", "")
          .replace(")", "")
          .split(",");

        return {
          lat: parseFloat(lat),
          lng: parseFloat(lng)
        };
      });

      if (coordinatesArray.length > 0) {
        const bounds = new google.maps.LatLngBounds();

        coordinatesArray.forEach(coord => {
          bounds.extend(coord);
        });

        map.fitBounds(bounds);
      }

      // destaca a rota EXISTENTE
      if (onDestacarRota && referenciaId) {
        onDestacarRota(referenciaId);
      }

      return;
    }

    // ========================
    // RECTANGLE
    // ========================
    if (type === "rectangule") {
      let coordsArray = typeof center === "string" ? JSON.parse(center) : center;

      if (Array.isArray(coordsArray) && coordsArray.length === 4) {
        const bounds = {
          north: parseFloat(coordsArray[3]),
          south: parseFloat(coordsArray[1]),
          east: parseFloat(coordsArray[2]),
          west: parseFloat(coordsArray[0]),
        };

        map.fitBounds(bounds);
      }

      return;
    }

    // ========================
    // POLYGON
    // ========================
    if (type === "polygon") {
      let polygonCoords = typeof center === "string" ? JSON.parse(center) : center;

      if (Array.isArray(polygonCoords)) {
        const bounds = new google.maps.LatLngBounds();

        polygonCoords.forEach(coord => {
          bounds.extend(coord);
        });

        map.fitBounds(bounds);
      }

      return;
    }
  };







  //EDIÇÃO DE AREA E ROTA
  const handleEditReferencia = (draw) => {

    const item = array_forms.find(
      (f) => f.id === draw.id
    );

    if (!item) return;

    const shape = item.shape;

    // ativa edição
    shape.setEditable(true);

    shape.setDraggable(true);

    // salva states
    setEditingId(draw.id);

    setEditingShape(shape);

    setIsEditing(true);

    // preenche campos
    setValues({

      descricao: draw.descricao || "",
    });

    setColor(draw.cor);

    toast.success("Modo edição ativado");
  };






  return (
    <>
      <div className="container-ref">

        {/* =====================================================
          SWITCH
      ===================================================== */}
        <div className="container-ref-switch">
          <input
            className="form-check-input"
            type="checkbox"
            checked={valor}
            onChange={() => handleFunction(index)}
          />
        </div>

        {/* =====================================================
          NOME
      ===================================================== */}
        <div className="container-ref-name">
          <p className="container-ref-title">
            {nome_referencia}
          </p>
        </div>

        {/* =====================================================
          AÇÕES
      ===================================================== */}
        <div className="container-ref-actions">

          {/* MOSTRAR NO MAPA */}
          <Tooltip
            title="Mostrar no mapa"
            arrow
            placement="bottom"
          >
            <button
              type="button"
              className="container-ref-action"
              onClick={handleCenter}
            >
              <BiSolidMapPin />
            </button>
          </Tooltip>

          {/* EDITAR */}
          <Tooltip
            title="Editar referência"
            arrow
            placement="bottom"
          >
            <button
              type="button"
              className="container-ref-action"
              onClick={() => {
                handleCenter();

                handleEditReferencia({
                  id: referenciaId,
                  tipo: type,
                });
              }}
            >
              <MdEdit />
            </button>
          </Tooltip>

          {/* EXCLUIR */}
          <Tooltip
            title="Excluir"
            arrow
            placement="bottom"
          >
            <button
              type="button"
              className="container-ref-action container-ref-delete"
              onClick={() =>
                confirmDelete(
                  {
                    nome_referencia,
                    id: referenciaId,
                  },
                  handleDelete
                )
              }
            >
              <FaRegTrashCan />
            </button>
          </Tooltip>

        </div>

      </div>
    </>
  );
}

export default InfoReferencia;
